var styles = {
  "main": "_main_ahrofk_64",
  "disabled": "_disabled_ahrofk_42",
  "slider": "_slider_ahrofk_19",
  "themeLight": "_themeLight_ahrofk_42",
  "themeDark": "_themeDark_ahrofk_45",
  "classic": "_classic_ahrofk_42",
  "rock": "_rock_ahrofk_49",
  "sizeS": "_sizeS_ahrofk_175",
  "sizeM": "_sizeM_ahrofk_180",
  "sizeL": "_sizeL_ahrofk_185"
};
export { styles as default };
